import React from "react";
import css from "./index.module.scss";
import Card from "@/components/card";
import Link from "next/link";

export default function TacticsSection({}) {
  return (
    <section className={`section ${css.tactics}`}>
      <div className="sectionInner">
        <h2 className="underlined">Tactics and Beyond</h2>
        <div className={css.subheadline}>We have diverse backgrounds, unique perspectives, and extensive experience across multiple marketing disciplines spanning a wide spectrum of industries. Below are some examples of tactics we have helped deploy for our clients as part of our devised marketing strategies.</div>

        <div className={css.cards}>
          <Card headline="Programmatic Advertising">
            <ul>
              <li>Meta Ads (Facebook / Instagram)</li>
              <li><Link href="/services/google-ads-optimization">Google Ads</Link></li>
              <li>YouTube Ads</li>
              <li>LinkedIn Ads</li>
              <li>TikTok Ads</li>
              <li>Microsoft Ads</li>
              <li>Quora Ads</li>
              <li>Reddit Ads</li>
              <li>Twitter Ads</li>
              <li>Pinterest Ads</li>
              <li>App Store Ads</li>
              <li>Other Platforms</li>
            </ul>
          </Card>

          <Card headline="Marketing Advisory">
            <ul>
              <li>Go-to-Market Strategy</li>
              <li>Product Launch Planning</li>
              <li>Marketing / Growth Budget Planning</li>
              <li>Growth Hacking Ideation</li>
              <li>Stunt Marketing Ideation</li>
              <li>Brand Voice Development</li>
              <li>Message &amp; Audience Testing</li>
              <li><Link href="/services/content-marketing">Content Marketing Strategy</Link></li>
              <li>Marketing Org Chart Advisory</li>
              <li>Product-Led Growth Ideation</li>
              <li>Community-Led Growth Ideation</li>
            </ul>
          </Card>

          <Card headline="Organic Growth">
            <ul>
              <li><Link href="/services/content-marketing">Content Marketing</Link></li>
              <li>AI-Based Content Creation</li>
              <li>Search Optimization (SEO)</li>
              <li>App Store Optimization (ASO)</li>
              <li>Sponsorship Strategies</li>
              <li>Celebrity Endorsements</li>
              <li>Co-Marketing</li>
              <li>Viral Campaign Development</li>
              <li>SEO-Focused PR</li>
              <li>Strategic Partnerships</li>
            </ul>
          </Card>

          <Card headline="Conversion Optimization">
            <ul>
              <li><Link href="/services/conversion-rate-optimization">Website Audit</Link></li>
              <li><Link href="/services/landing-page-development">Landing Page Development</Link></li>
              <li>Lead Magnet Creation</li>
              <li>Copy Audit</li>
              <li><Link href="/services/seo-advisory">On-Site SEO Advisory</Link></li>
              <li>Keyword Research / Planning</li>
              <li>Email Marketing</li>
              <li>Heatmap Analysis</li>
              <li>A/B Testing</li>
              <li>Marketing AI / Machine Learning Optimization</li>
              <li><Link href="/services/high-performance-landing-pages">High Performance Landing Pages</Link></li>
              <li><Link href="/services/user-acquisition">User Acquisition</Link></li>
              <li><Link href="/services/post-universal-analytics">Post Universal Analytics Tracking</Link></li>
            </ul>
          </Card>

          <Card headline="Saas Marketing">
            <ul>
              <li>Performance Marketing</li>
              <li>Account-Based Marketing</li>
              <li>Email Automation</li>
              <li>Full-Funnel Development</li>
              <li>Lead Buys (Gartner &amp; Others)</li>
              <li>Product Hunt Launch</li>
              <li>App Store Ads</li>
              <li>Integration Strategy</li>
              <li>Sales Collateral Creation</li>
              <li>Among Other Items</li>
            </ul>
          </Card>

          <Card headline="Other">
            <ul>
              <li><Link className="link" href="/services/stunt-marketing">Stunt Marketing</Link></li>
              <li><Link href="/services/influencer-marketing">Influencer Marketing</Link></li>
              <li>Investor Marketing</li>
              <li><Link href="/services/high-performance-ad-creatives">Ad Design</Link></li>
              <li>Mascot Creation</li>
              <li>Jingle / Slogan Development</li>
              <li><Link className="link" href="/services/sonic-branding">Sonic Branding</Link></li>
              <li>Contest Campaigns</li>
              <li>Funnel Development</li>
              <li>Email Marketing</li>
              <li>Direct Ad Buys</li>
              <li>Podcast Advertising</li>
              <li>Marketing Automation</li>
              <li>Marketing Insights / Analytics</li>
            </ul>
          </Card>

        </div>
      </div>
    </section>
  );
}

